import { KnowledgeBaseSyncProvider } from "@repo/app-types/entities/knowledgeBaseSync";
import { format } from "date-fns";
import type { FC } from "react";
import kustomerLogoSrc from "../../../assets/integrations/kustomerLogo.png";

interface KnowledgeBaseSyncPillProps {
  provider: KnowledgeBaseSyncProvider;
  lastSyncedAt: string | null;
}

export const KnowledgeBaseSyncPill: FC<KnowledgeBaseSyncPillProps> = (
  props,
) => {
  const { provider, lastSyncedAt } = props;

  return (
    <div className="flex h-7 items-center gap-1.5 text-xs font-medium text-muted-foreground">
      <img
        alt={provider === KnowledgeBaseSyncProvider.KUSTOMER ? "Kustomer" : ""}
        className="size-5 shrink-0 rounded-md object-contain"
        src={kustomerLogoSrc}
      />
      {lastSyncedAt ? (
        <time dateTime={lastSyncedAt}>
          Last synced{" "}
          {format(new Date(lastSyncedAt), "MMM d, yyyy 'at' h:mm a")}
        </time>
      ) : (
        <span>Not synced yet</span>
      )}
    </div>
  );
};
